import { render } from "./EvmCoinBNBDepositManual.vue?vue&type=template&id=cb3397b2"
import script from "./EvmCoinBNBDepositManual.vue?vue&type=script&lang=js"
export * from "./EvmCoinBNBDepositManual.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__